import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Checkbox from '../../../../../components/Checkbox/Index';
import DropDown from '../../../../../components/DropDown/DropDown';
import KebabIcon from '../../../../../assets/svg/icons/common/kebab';
import WarningIcon from '../../../../../assets/svg/icons/common/Warning';
import RiskIcon from '../../../../../assets/svg/icons/common/risk';
import ConfirmationModal from '../../../../application/components/ConfirmationModal/ConfirmationModal';
import { RemoveMcc } from '../../../../../../api';
import toast from 'react-hot-toast';
import useMccStore from '../../../../../stores/mcc';

const Row = ({ data, fetchData }) => {

  const [deleteModal, setDeleteModal] = useState(false);
  const isMountedRef = useRef(true);

  const setRecordToEdit = useMccStore((state) => state.setRecordToEdit);
  const setIsAddMCCModalOpen = useMccStore((state) => state.setIsAddMCCModalOpen);
  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const dropDownOptions = [
    {
      text: "Edit",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data)
        setIsAddMCCModalOpen(true);
      },
    },
    {
      text: "Delete Code",
      type: "danger",
      onClick: () => {
        setDeleteModal(true)
      },
    },
  ];

  const deleteMcc = async () => {
    const toastId = toast.loading('Deleting...');
    const response = await RemoveMcc(data?.id);
    if (response?.success) {
      toast.success("Deleted successfully", { id: toastId, duration: 5000 });
      if (isMountedRef.current) fetchData();
      setDeleteModal(false)
    } else {
      toast.error("Failed to delete MCC code", { id: toastId, duration: 5000 });
      setDeleteModal(false)
    }
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedMcc([...selectedMcc, +value]);
    } else {
      setSelectedMcc(selectedMcc.filter((id) => id !== +value));
    }
  };

  return (
    <>
      <tr className={styles.tbodyRow} >
        <td className={styles.td} >
          <Checkbox
            checked={selectedMcc.includes(data.id)}
            value={data.id}
            onChange={handleCheckboxChange}
          />
        </td>
        <td className={styles.td} >
          {data?.id}
        </td>
        <td className={styles.td} >
          {data?.mcc}
        </td>
        <td className={styles.td} >
          {data?.category}
        </td>
        <td className={styles.td} >
          {data?.description}
        </td>
        <td>
          <div className={styles.flex} >
            {data.risk ? (
              <>
                {data.risk === 'high_risk' ? (
                  <WarningIcon />
                ) : (
                  <RiskIcon />
                )}
                <span>
                  {data.risk?.split("_")?.[0]}
                </span>
              </>
            ) : (
              <>
                <span>-</span>
              </>
            )}

          </div>
        </td>
        <td className={styles.td} >
          <DropDown options={dropDownOptions} >
            <KebabIcon />
          </DropDown>
        </td>
      </tr>

      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          onClose={() => {
            setDeleteModal(false);
          }}
          message={"Are you sure you want to delete selected mcc code? You can’t undo this action."}
          onConfirmClick={deleteMcc}
        />
      )}
    </>
  )
}

export default Row;